// extracted by mini-css-extract-plugin
export default {"asset_wrapper":"UploadingThumbnail_asset_wrapper__fMJQG"};